export const TAG_COLORS = [
  { value: 0, key: 'grey' },
  { value: 1, key: 'blue' },
  { value: 2, key: 'yellow' },
  { value: 3, key: 'orange' },
  { value: 4, key: 'red' },
  { value: 5, key: 'green' },
];

export const DEFAULT_TAG_COLOR = TAG_COLORS[0].value;

export const getTagColorKey = value => (TAG_COLORS.find(c => c.value === value) || TAG_COLORS[0]).key;
